import { AttachmentRepository } from '@webapp/core/data-access/repositories/AttachmentRepository/AttachmentRepository'
import { ApiClient } from '@webapp/core/services/ApiClient'

export const attachmentRepository = new AttachmentRepository({
  httpClient: ApiClient,
})
